"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonHeading = void 0;

var _commonHeading = _interopRequireDefault(require("./components/common-heading"));

exports.CommonHeading = _commonHeading["default"];